import * as React from "react";
import { forwardRef } from "react";
import styled, { css } from "styled-components";
import { ListGroupItem } from "components/bootstrap";
import DragHandle from "components/common/SortableList/DragHandle";
const StyledListGroupItem = styled(ListGroupItem)(
  ({ $alignItemContent }) => css`
    display: flex;
    align-items: ${$alignItemContent};
  `
);
const ListItem = ({
  alignItemContent = "flex-start",
  className = void 0,
  customContentRender = void 0,
  customListItemRender = void 0,
  disableDragging = false,
  dragHandleProps,
  index,
  isDragging,
  item
}, ref) => {
  const itemContent = customContentRender ? customContentRender({ item, index }) : item.title;
  const dragHandle = disableDragging ? null : /* @__PURE__ */ React.createElement(DragHandle, { dragHandleProps, itemTitle: item.title, index, isDragging });
  if (customListItemRender) {
    return /* @__PURE__ */ React.createElement(React.Fragment, null, customListItemRender({
      className,
      disableDragging,
      dragHandle,
      index,
      item,
      ref
    }));
  }
  return /* @__PURE__ */ React.createElement(StyledListGroupItem, { $alignItemContent: alignItemContent, ref, className }, dragHandle, itemContent);
};
export default forwardRef(ListItem);
